// const API_BASE_URL = 'https://development.wastepilot.us/api/v1';
const API_BASE_URL = 'https://staging.wastepilot.us/api/v1';

const API_ENDPOINTS = {
  SINGLE_DUMPSTER_DETAILS: (slug, dumpsterSizeId) =>
    `${API_BASE_URL}/dumpster-sizes/company/${slug}/${dumpsterSizeId}`,
  COMPANY_DUMPSTER_DETAILS: (slug) =>
    `${API_BASE_URL}/dumpster-sizes/company/${slug}`,
  ORDER_BILLING: (slug) => `${API_BASE_URL}/company/${slug}/order/billing`,
  ORDER_PLACE: (slug) => `${API_BASE_URL}/company/${slug}/order/place`,
  UPLOAD_MEDIA: () => `${API_BASE_URL}/upload-media`, // ✅ new endpoint
  WASTE_TYPES: () => `${API_BASE_URL}/waste-types`,
};

export default API_ENDPOINTS;
